import { http } from './http.helper';
import { snakeToCamelCase } from "../utils/common";

export const Api = {

    saveImage: (data) => http({ path: '/forms/builder/save-image', data }),

    saveFormConfig: (data) => http({ path: '/forms/builder/save-config', data }),

    updateFormConfig: (formId, data) => http({ path: '/forms/builder/' + formId + '/update-config', data }),

    updateSuccessPageConfig: (formId, data) => http({ path: '/forms/builder/success-page-config/' + formId, data, method: 'PUT' }),

    sendEmail: ({ email, resultId }) => {
        var postData = {
            email: email,
            resultId: resultId
        };
        http({ path: '/form/send-email', method: 'POST', data: JSON.stringify(postData) });
    },

    sendFiles: ({ resultId, data }) => http({ path: '/form/feedback/' + resultId + '/save-files', data, isFile: true }),

    sendForm: ({ isFromDownloader, files, url, email, result, registrationData }) => {

        const { pathname, search } = window.location;
        let path = pathname + '/save';

        const params = Object.fromEntries(new URLSearchParams(search).entries());
        if (params && params.hasOwnProperty('email')) {
            path += '&attendeeEmail=' + params.email;
        }

        const currentParams = new URLSearchParams(window.location.search);
        let queryParams = {};

        currentParams.forEach((value, key) => {
            queryParams[snakeToCamelCase(key)] = value
        });

        let requestData = {
            result,
            registrationData,
            queryParams
        }

        return http({ path, data: JSON.stringify(requestData) });
    },

    registerFeedback: ({ type, registUrl, data }) => {
        let path = registUrl + '/api/user';

        switch (type) {
            case 'registration':
                path += '/register-feedback';
                break;
            case 'confirmation':
                path += '/pre-register-feedback';
                break;
            default: return;
        }

        const url = new URL(path);

        const currentParams = new URLSearchParams(window.location.search);

        currentParams.forEach((value, key) => {
            url.searchParams.append(snakeToCamelCase(key), value);
        });

        path = url.toString();

        return http({ path, data: JSON.stringify(data) });
    },

    getGroups: (baseUrl, event_id) => http({ path: `${baseUrl}/api/user/groups/${event_id}`, method: 'GET' }),

    setIframeMode: (formId, data) => http({ path: `/forms/${formId}/is-iframe-mode`, data, method: 'POST' }),
}
